module.exports = __webpack_public_path__ + "img/MoviePosterMania.3ece8936.png";